import { render, staticRenderFns } from "./minCom.vue?vue&type=template&id=8f206478"
import script from "./minCom.vue?vue&type=script&lang=js"
export * from "./minCom.vue?vue&type=script&lang=js"
import style0 from "./minCom.vue?vue&type=style&index=0&id=8f206478&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/crm-admin-uat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f206478')) {
      api.createRecord('8f206478', component.options)
    } else {
      api.reload('8f206478', component.options)
    }
    module.hot.accept("./minCom.vue?vue&type=template&id=8f206478", function () {
      api.rerender('8f206478', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CustomerDrawerCom/logCom/minCom.vue"
export default component.exports